<script lang="ts">
  export let name = '';
  export let closable = false;

  import { createEventDispatcher } from 'svelte';
  import Button from './iconButton.svelte';
  import VerticalCenter from './verticalCenter.svelte';
  import Center from './center.svelte';
  import XIcon from '../icons/x.svelte';

  let dispatch = createEventDispatcher<{ close: any }>();
</script>

<header
  style={closable ? 'grid-template-columns: calc(100% - 40px) 30px;' : 'text-align: center'}
>
  <VerticalCenter>
    <h1>{name}</h1>
  </VerticalCenter>

  {#if closable}
    <VerticalCenter>
      <Button on:click={e => dispatch('close', e)}>
        <Center>
          <XIcon />
        </Center>
      </Button>
    </VerticalCenter>
  {/if}
</header>

<style>
  header {
    display: grid;
    gap: 10px;
    grid-template-columns: 100%;
    padding: 12px 12px 11px 20px;
    border-bottom: solid var(--loop-headerBorder) 1px;
    background: var(--loop-headerBackground);
    position: sticky;
    top: 0px;
    /* z-index: 9999; */
  }

  header h1 {
    margin: 0px;
    font-weight: 500;
    font-size: 18px;
    display: block;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>
